
let API_BASE_URL = "";

const hostname = window.location.hostname;

let  APP_BASE_URL = `https://${hostname}`;

API_BASE_URL = "https://n99qcn7b66.execute-api.us-east-1.amazonaws.com/integrate";

// if (hostname.includes("test") || hostname.includes("stage") || hostname.includes("ngrok")) {
//     API_BASE_URL = "https://n99qcn7b66.execute-api.us-east-1.amazonaws.com/integrate";
// } else {
//     API_BASE_URL = "https://yc3gsh0ec1.execute-api.us-east-1.amazonaws.com/api";
// }
export { API_BASE_URL, APP_BASE_URL };

export const IPQSKey = "AwTSkX9iOEW9zRAAnPqCYtIpE3S8qRntOgiz7ZYv23lXIj9FfnChQTnn6Z7s8D5FHZ1Lmylgwn5xIKbU9YPZ4SE4PV8t2nSEKkkBoRdIMYngt1WRcn3iGOLCEtE5Lydx1pZQhCv5pKikXuevjl09p9wxVQvKU7cMxH3krKnFn2laEukhflgGHgrfRlYflXxNzsvr9WFKbh7Z7C6vmeBwEx9cW8jwX4i3dUZLoKB26WGqJ5IdkpPwcbcCVmBD3phM";
export  const SALT_KEY = "gatheringjar$@0047";
export const APP_CLIENT_ID = "2d4b2d47-2011-4b9e-b789-dbacff73382e";





